// Module
var code = "<ca-article-list\n    articles=\"vm.articles\"\n    filter=\"vm.filter\"\n    current-page=\"vm.currentPage\"\n    page-size=\"vm.pageSize\"\n    on-article-selected=\"vm.selectArticle(article)\"\n    show-new-button=\"false\"\n    show-filter-dropdown=\"true\"\n    ></ca-article-list>\n";
// Exports
module.exports = code;